import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { FRONT_PHOTOSPHERE_SELECTOR } from "../../../crossconcern/utilities/properties/selector.property";
import { BaseComponent } from "../../base/base.component";
import { PhotosphereManager } from "../../../business/managers/photosphere.manager";
import { AppComponent } from "../../app.component";
import { Router } from "@angular/router";
import { finalize } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";
import { AlertUtils } from "../../../crossconcern/utilities/utils/alert.utils";
import { Location } from "@angular/common";
import { GenericService } from "../../../crossconcern/services/generic.services";
import { NurseryModel } from "../../../datastore/entities/nursery.model";
import { DIM_BREAKPOINT_DESKTOP_WIDTH } from "../../../crossconcern/utilities/properties/base.property";
@Component({
    selector: FRONT_PHOTOSPHERE_SELECTOR,
    templateUrl: "./frontphotosphere.component.html"
})
export class FrontPhotosphereComponent extends BaseComponent implements OnInit {

    @Input() public isBack = false;
    @Input() public sphereUUID: string = null;
    @Input() public nurseryUUID: string = null;

    public isSidebarOpen = true;
    public sidebarMode = "over";
    public menuButtonMarginLeft = 0;
    @ViewChild("sidebar", null) private sidebarElement;

    // Array containing only the one nursery (the one with nurseryUUID)
    // Used as a frontsidebar component parameter
    public nurseries: NurseryModel[] = [];

    constructor(
        protected translate: TranslateService,
        protected appComponent: AppComponent,
        protected router: Router,
        protected genericService: GenericService,
        private photosphereManager: PhotosphereManager,
        protected location: Location,
        protected alertUtils: AlertUtils) {
        super(appComponent, router, alertUtils, location);
    }

    ngOnInit(): void {
        this.init();
    }

    private init() {
        this.appComponent.startLoading();
        this.photosphereManager.getPhotospheres(1, 0, this.nurseryUUID, true)
            .pipe(
                finalize(() => this.appComponent.stopLoading())
            )
            .subscribe((photosphereList) => {
                this.nurseries.push(photosphereList.photospheres[0].nursery);
            });

        this.isSidebarOpen = window.innerWidth > DIM_BREAKPOINT_DESKTOP_WIDTH;
        if (this.isSidebarOpen) {
            this.menuButtonMarginLeft = 300;
        } else {
            this.menuButtonMarginLeft = 0;
        }
    }

    // Sidebar

    public toggleSidebar() {
        this.isSidebarOpen = !this.isSidebarOpen;
        if (this.isSidebarOpen) {
            this.menuButtonMarginLeft = 300;
        } else {
            this.menuButtonMarginLeft = 0;
        }
    }

    public refreshSidebar() {
        setTimeout(() => {
            this.sidebarElement.triggerRerender();
        }, 900);
    }
}
